import apiClient from "../client";

// GET /api/macs
// Returns all MACs with nested SOWs — drives the PMO sidebar
export const getMacsWithSows = async () => {
  const response = await apiClient.get("/macs");
  return response.data;
};

// GET /api/macs/{macId}/sows
// Returns active SOWs for a specific MAC
// Used in MAC Leader SOW tab bar
export const getSowsByMac = async (macId) => {
  const response = await apiClient.get(`/macs/${macId}/sows`);
  return response.data;
};


export const getMacsList = async () => {
  const response = await apiClient.get("/macs/list");
  return response.data;
};